import Head from 'next/head'
import PageHeaderBanner from '@bww/beke-ui/PageHeader'

import { siteConfig } from '@bww/beke-lib/site-config'

export default function OurStoryPage() {
  return (
    <>
      <Head>
        <title>Our Story | About Bathroom Elegance</title>
      </Head>
      <PageHeaderBanner
        title="Our Story"
        categoryTitle="About Bathroom Elegance"
        noMargin
      />
      <div className="pageContainer">
        <h2
          className="h3"
          style={{ color: 'var(--color-primary)', marginBottom: 20 }}
        >
          Creating beautiful bathrooms since 2007
        </h2>
        <p>
          Rob and Carolyn Rosselli launched Bathroom Elegance after 21 years'
          success creating luxury kitchens across Dorset and Hampshire with{' '}
          <a href={siteConfig.sisterCompany.url}>Kitchen Elegance</a>.
        </p>
        <p>
          Bathroom Elegance's 4,000 square foot showroom within the Nuffield
          Industrial Estate in Poole (next to the Smyths toy store) includes
          room sets featuring everything that you could possibly require.
        </p>
        <p>
          Whether you are looking for a striking en-suite, or something
          affordable for a family bathroom or guest room, you are sure to find a
          wide choice at Bathroom Elegance.
        </p>
        <p>
          Bathroom Elegance can supply a carefully chosen selection of the
          latest innovative bathroom solutions such as steam rooms, glass
          radiators, bespoke shower doors, built in TVs, and chromotherapy
          showers — with many more items on display in the showroom.
        </p>
        <p>
          Our team delivers items directly to your home instead of using
          national couriers; this ensures the utmost care is taken when handling
          your goods and provides the peace of mind that your products will
          arrive in perfect condition.
        </p>
        <p>
          Our bathroom experts will help guide you through the large selection
          of products and design your ideal space; creating a place to relax
          that will be a real asset to your home.
        </p>
      </div>
    </>
  )
}
